import { render, staticRenderFns } from "./BrandValue.vue?vue&type=template&id=32fe24e3"
import script from "./BrandValue.vue?vue&type=script&lang=js"
export * from "./BrandValue.vue?vue&type=script&lang=js"
import style0 from "./BrandValue.vue?vue&type=style&index=0&id=32fe24e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports